module.exports = __webpack_public_path__ + "media/img/home/directions/list-10-cd1df2fd4671bb033a581fbbe9ac8588.svg";